import styled from 'styled-components';
import { deviceBreakpoints } from '@cbhq/cds-web/layout/breakpoints';
import '../../../Link/index.js';
import { NavBody, NavBodyBold } from '../../NavTypography.js';
import Link from '../../../Link/Link.js';
const ITEM_MIN_HEIGHT = 72;
const COLUMN_GAP = 16;
const ColumnWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(300px, max-content));
  @media (min-width: ${deviceBreakpoints.desktop}px) {
    grid-template-columns: repeat(2, minmax(360px, max-content));
  }
  column-gap: ${COLUMN_GAP}px;
  grid-auto-flow: row;
  justify-content: end;
  margin-right: 32px;
  align-items: flex-start;
`;
const DescriptionText = styled(NavBody)`
  margin-top: 4px;
  display: inline-block;
  color: ${({
  theme
}) => theme.color.textLight};
  line-height: 20px;
`;
const ItemWrapper = styled(Link)`
  display: inline-flex;
  color: inherit;
  width: 100%;
  min-height: ${ITEM_MIN_HEIGHT}px;
  padding: 16px;
  font-size: 14px;
  &:hover {
    ${NavBodyBold} {
      color: ${({
  theme
}) => theme.color.textHover};
    }
    ${DescriptionText} {
      color: ${({
  theme
}) => theme.color.text};
    }
  }
`;
const ColumnHeaderLink = styled(Link)`
  color: ${({
  theme
}) => theme.color.text};
  width: ${({
  $fullWidth
}) => $fullWidth ? '100%' : 'auto'};

  &:hover {
    color: ${({
  theme
}) => theme.color.textHover};
  }

  * {
    color: inherit;
  }
`;
export { ColumnHeaderLink, ColumnWrapper, DescriptionText, ItemWrapper };
//# sourceMappingURL=styles.js.map
